import axiosIns from '@/libs/axios'
import uploadWithProgress from '@/store/helpers/upload'

const ROOT_URL = '/Admin/data/project_files'
export default {
  namespaced: true,
  state: {
    loading: false,
    secretLoading: false,
    uploading: false,
    uploadProgress: {
      loaded: 0,
      total: 0,
    },
    dataList: [],
    dataListSecret: [],
    dataCounts: 0,
    dataListSecretCounts: 0,
    dataItem: {
      id: null,
      id_licenses: null,
      unique_hash: null,
      title: null,
      notes: null,
      file_name: null,
      file_type: null,
      file_size: null,
      is_secret: '0',
      id_document_groups: null,
      id_projects: null,
      id_users: null,
    },
    dataSave: {
      message: null,
      status: null,
      id: null,
    },
    filterParams: {
      id_projects: null,
      id_document_groups: null,
      keywords: null,
    },
  },
  getters: {
    loading(state) {
      return state.loading
    },
    secretLoading(state) {
      return state.secretLoading
    },
    uploading(state) {
      return state.uploading
    },
    uploadProgress(state) {
      return state.uploadProgress
    },
    dataList(state) {
      return state.dataList
    },
    dataListSecret(state) {
      return state.dataListSecret
    },
    dataCounts(state) {
      return state.dataCounts
    },
    dataCountsSecret(state) {
      return state.dataListSecretCounts
    },
    dataItem(state) {
      return state.dataItem
    },
    dataSaveStatus(state) {
      return state.dataSave
    },
    filterParams(state) {
      return state.filterParams
    },
  },
  mutations: {
    SET_LOADING(state, data) {
      state.loading = data
    },
    SET_LOADING_SECRET(state, data) {
      state.secretLoading = data
    },
    SET_UPLOADING(state, data) {
      state.uploading = data
    },
    SET_UPLOAD_PROGRESS(state, data) {
      state.uploadProgress = data
    },
    SET_DATA_LIST(state, data) {
      state.dataList = data
    },
    SET_SECRET_DATA_LIST(state, data) {
      state.dataListSecret = data
    },
    SET_DATA_ITEM(state, data) {
      state.dataItem = data
    },
    SET_DATA_COUNTS(state, data) {
      state.dataCounts = data
    },
    SET_SECRET_DATA_COUNTS(state, data) {
      state.dataListSecretCounts = data
    },
    SET_DATA_SAVE(state, data) {
      state.dataSave = data
    },
    RESET_DATA_ITEM(state) {
      state.dataItem = {
        id: null,
        id_licenses: null,
        unique_hash: null,
        title: null,
        notes: null,
        file_name: null,
        file_type: null,
        file_size: null,
        is_secret: '0',
        id_document_groups: null,
        id_projects: null,
        id_users: null,
      }
    },
  },
  actions: {
    getDataList({ commit }, params) {
      commit('SET_LOADING', true)
      commit('RESET_DATA_ITEM')
      commit('SET_DATA_LIST', [])
      const data = JSON.stringify(params)
      axiosIns
        .post(ROOT_URL, data)
        .then(response => {
          commit('SET_DATA_LIST', response.data.data)
          commit('SET_DATA_COUNTS', response.data.count)
          commit('SET_LOADING', false)
        })
        .catch(error => console.error(error))
    },
    getSecretDataList({ commit }, params) {
      commit('SET_LOADING_SECRET', true)
      commit('RESET_DATA_ITEM')
      commit('SET_SECRET_DATA_LIST', [])
      const data = JSON.stringify(params)
      axiosIns
        .post(ROOT_URL, data)
        .then(response => {
          commit('SET_SECRET_DATA_LIST', response.data.data)
          commit('SET_SECRET_DATA_COUNTS', response.data.count)
          commit('SET_LOADING_SECRET', false)
        })
        .catch(error => console.error(error))
    },
    async getDataItem({ commit }, id) {
      if (Number(id)) {
        commit('SET_LOADING', true)
        commit('RESET_DATA_ITEM')
        const data = {
          where: {
            'project_files.id': id,
          },
          array: false,
        }
        return axiosIns
          .post(ROOT_URL, data)
          .then(response => {
            commit('SET_DATA_ITEM', response.data.data)
            commit('SET_LOADING', false)
            return response.data.data
          })
          .catch(error => console.error(error))
      }
      return false
    },
    saveData({ commit }, postData) {
      const formData = new FormData()
      formData.append('id', postData.id)
      formData.append('title', postData.title)
      formData.append('notes', postData.notes)
      formData.append('is_secret', postData.is_secret)
      formData.append('id_document_groups', postData.id_document_groups)
      formData.append('id_projects', postData.id_projects)
      formData.append('upload_file', postData.upload_file)
      return uploadWithProgress(commit, `${ROOT_URL}/saveData`, formData)
    },
    removeData({ commit }, id) {
      commit('SET_LOADING', true)
      return axiosIns
        .post(`${ROOT_URL}/deleteData`, { id })
        .then(response => {
          commit('SET_DATA_SAVE', response.data)
          commit('SET_LOADING', false)
          return response.data
        })
        .catch(error => console.error(error))
    },
  },
}
